import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import FPSRangeAction from "./FPSRangeAction.js";
/**
 * @extends SDK.Action
 * @memberOf Actions.Transcode
 * @description Controls the FPS (Frames Per Second) to ensure that video (even when optimized)
 * is delivered with
 * an expected FPS level (helps with sync to audio).
 *
 * <b>Learn more</b>: {@link https://cloudinary.com/documentation/video_transformation_reference#video_settings|Video settings}
 * @see Visit {@link Actions.Transcode|Transcode} for an example
 */

var FPSAction = /*#__PURE__*/function (_Action) {
  _inherits(FPSAction, _Action);

  var _super = _createSuper(FPSAction);

  function FPSAction(from) {
    var _this;

    _classCallCheck(this, FPSAction);

    _this = _super.call(this);
    _this._actionModel = {
      actionType: 'fps'
    };
    _this._actionModel.fps = from;

    _this.addQualifier(new Qualifier('fps', from));

    return _this;
  }

  _createClass(FPSAction, null, [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var fps = actionModel.fps;
      var result;

      if (typeof fps === 'object') {
        //@ts-ignore
        result = new FPSRangeAction(fps.from, fps.to);
      } else {
        result = new this(fps);
      } // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created


      return result;
    }
  }]);

  return FPSAction;
}(Action);

export default FPSAction;